// extracted by mini-css-extract-plugin
module.exports = {"container":"ColladaOverlayCine-styles-module--container--2XJTT"};